module.exports = __webpack_public_path__ + "static/media/filter.08d5e5ad.svg";